import React from "react";

const FooterBanner: React.FC = () => {
  return (
    <div className="fixed z-50 bottom-0 left-0 w-full font-euro font-bold bg-orange text-white text-center py-2 md:flex justify-center">
      <p className="text-lg">Connect with me:</p>
      <p className="md:ml-1 text-lg">lukearcherdesigner&#64;gmail.com</p>
    </div>
  );
};

export default FooterBanner;
